module.exports = __webpack_public_path__ + "static/media/authBackground.bc433582.jpg";